export const VUEX_PRODUCTS = 'VUEX_PRODUCTS'
export const VUEX_PRODUCT_GET = 'VUEX_PRODUCT_GET'
export const VUEX_PRODUCT_INDEX = 'VUEX_PRODUCT_INDEX'
export const VUEX_PRODUCT_INDEX_SUCCESS = 'VUEX_PRODUCT_INDEX_SUCCESS'
export const VUEX_PRODUCT_INDEX_FAILURE = 'VUEX_PRODUCT_INDEX_FAILURE'
